import { useEffect } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { ScreenContextType } from 'navigation/wrapper/screen/ScreenWrapper';

export const NoFooterScreenWrapper = () => {
  const { setScreenVariant } = useOutletContext<ScreenContextType>();

  useEffect(() => {
    setScreenVariant('Default', 'None');
  }, []);

  return <Outlet />;
};
